import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import SuggestSelectInput from '../../../../Common/suggestSelectInput';
import Validator from '../../../../Common/validator';

class DeliveryNote extends Component{
  shouldComponentUpdate = (nextProps) => {
    return nextProps.deliveryNote!==this.props.deliveryNote
  };
  render()  {
    const { deliveryNote: { number, supplier, specification },
    updateDeliveryNote, updateDeliveryNoteTouched, supplierSuggestions, getSupplierSuggestions,
    isNumberValid, isSupplierValid } = this.props;
    return (
      <div className="row" style={styles.container}>
        <div style={styles.firstColumn} className="col-xs-4">
          <Validator isValid={isNumberValid}>
            <input
              style={styles.input}
              value={number}
              onChange={(evt) => updateDeliveryNote('number', evt.target.value)}
              onBlur={() => updateDeliveryNoteTouched('numberTouched')}
              placeholder="..."
            />
          </Validator>
        </div>
        <div className="col-xs-3">
          <Validator isValid={isSupplierValid}>
            <SuggestSelectInput
              onQuery={getSupplierSuggestions}
              suggestions={supplierSuggestions}
              onChange={(val) => updateDeliveryNote('supplier', val.name)}
              value={{id: supplier, name: supplier}}
              inputStyle={styles.input}
              onBlur={() => updateDeliveryNoteTouched('supplierTouched')}
              placeholder="..."
            />
          </Validator>
        </div>
        <div className="col-xs-4">
          <input
            style={styles.input}
            value={specification}
            onChange={(evt) => updateDeliveryNote('specification', evt.target.value)}
            placeholder="..."
          />
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    margin: '0 0 6px 0'
  },
  firstColumn: {
    paddingLeft: '0'
  },
  input : {
    '-webkit-appearance': 'none',  
    border: 'none',
    display: 'block',
  }
}
  DeliveryNote.propTypes = {
    deliveryNote: PropTypes.shape({
      number: PropTypes.string.isRequired,
      supplier: PropTypes.string.isRequired,
      specification: PropTypes.string,
      numberTouched: PropTypes.bool,
      supplierTouched: PropTypes.bool
    }).isRequired,
    isNumberValid: PropTypes.bool.isRequired,
    isSupplierValid: PropTypes.bool.isRequired,
    updateDeliveryNote: PropTypes.func.isRequired,
    updateDeliveryNoteTouched: PropTypes.func.isRequired,
    getSupplierSuggestions: PropTypes.func.isRequired,
    supplierSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }))
  };
export default Radium(DeliveryNote)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/DeliveryNotes/deliveryNote.jsx